
import { async_command_dispatcher } from "@/api/client"

export class SetCdbLoadPathsConfirmationMailCommand {
    
    constructor() {}

    async run(company_ids: Array<number>, confirmation_mail: boolean) {
        
        let args = {company_ids: company_ids, send_confirmation_mail: confirmation_mail}
        console.log("run SetCdbLoadPathsConfirmationMailCommand")

        let resOutput
        try {
            resOutput = await async_command_dispatcher.dispatch_with_result('set.cdb.loadpath.conf.mail', args, 1000)
        } catch (error) {
            console.error('Error updating confirmation_email', error)
            resOutput = null
        }
        
        if (!resOutput) return null
        else if (Array.isArray(resOutput)) return resOutput
        return null
    }
}